import {BaseEntity} from '../../common/base-entity';
import {CirfField} from './cirf-field';

export class CirfTopicSection extends BaseEntity {
    sectionLabel: string;
    sectionKey: string;
    cirfFields: CirfField[];

    constructor(section?: CirfTopicSection) {
        super(section);
        if (section) {
            if (section.cirfFields) {
                this.cirfFields = section.cirfFields.map(field => new CirfField(field));
            }
        } else {
            this.cirfFields = [];
        }
    }
}
